var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.deliverableDetail,
          expression: "deliverableDetail"
        }
      ],
      staticClass: "edit-deliverable-modal",
      class:
        !_vm.userAbilities.editMediaCall ||
        _vm.deliverableDetail.permissions.viewOnly
          ? "read-only"
          : ""
    },
    [
      _vm.isParentProjectOnHold(_vm.deliverableDetail.project_id)
        ? _c("div", { staticClass: "deliverable-project-on-hold-header" }, [
            _c("div", { staticClass: "icon-wrapper" }, [
              _c("img", {
                attrs: {
                  src: require("@/csmworkflow/img/project-on-hold-icon.svg")
                }
              })
            ]),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Project On Hold - " +
                  _vm._s(_vm.deliverableDetail.project_id.name)
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "departments__wrapper" },
        [
          _c("DeliverableDropdown", {
            attrs: {
              deliverable: _vm.deliverableDetail,
              deliverableTypes: _vm.deliverableTypes,
              classNames: "department-title"
            }
          }),
          _vm._v(" "),
          _vm.isMobile() && _vm.showDepartment()
            ? _c("DeliverableDepartments", {
                attrs: {
                  deliverable: _vm.deliverableDetail,
                  namespace: _vm.namespace
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("DeliverableProjects", {
            attrs: {
              deliverable: _vm.deliverableDetail,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isMobile()
        ? _c("label", { staticClass: "form-group w-100 sticky__delv__title" }, [
            _c(
              "h1",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editTitle,
                    expression: "!editTitle"
                  }
                ],
                staticClass:
                  "exclude-outside-click edit-d-title deliverable-title",
                on: { click: _vm.activateTitleField }
              },
              [_vm._v(_vm._s(_vm.deliverableDetail.title || "Click to set..."))]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editTitle,
                  expression: "editTitle"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.deliverableDetail.title,
                  expression: "deliverableDetail.title"
                }
              ],
              ref: "deliverableTitle",
              staticClass:
                "form-control mb-3 title-field exclude-outside-click h1",
              attrs: {
                type: "text",
                placeholder: _vm.getDeliverableTitlePlaceholder
              },
              domProps: { value: _vm.deliverableDetail.title },
              on: {
                change: _vm.updateDeliverableTitle,
                blur: function($event) {
                  _vm.editTitle = false
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.deliverableDetail, "title", $event.target.value)
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-5" },
          [
            !_vm.isMobile() && _vm.showDepartment()
              ? _c("DeliverableDepartments", {
                  attrs: {
                    deliverable: _vm.deliverableDetail,
                    namespace: _vm.namespace
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isMobile()
              ? _c("label", { staticClass: "form-group w-100" }, [
                  _c(
                    "h1",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editTitle,
                          expression: "!editTitle"
                        }
                      ],
                      staticClass:
                        "exclude-outside-click edit-d-title deliverable-title",
                      on: { click: _vm.activateTitleField }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.deliverableDetail.title || "Click to set...")
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.outside,
                        expression: "outside"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editTitle,
                        expression: "editTitle"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.deliverableDetail.title,
                        expression: "deliverableDetail.title"
                      }
                    ],
                    ref: "deliverableTitle",
                    staticClass:
                      "form-control mb-3 title-field exclude-outside-click h1",
                    attrs: {
                      type: "text",
                      placeholder: _vm.getDeliverableTitlePlaceholder
                    },
                    domProps: { value: _vm.deliverableDetail.title },
                    on: {
                      change: _vm.updateDeliverableTitle,
                      blur: function($event) {
                        _vm.editTitle = false
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.deliverableDetail,
                          "title",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-7" }, [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "div",
              { staticClass: "tags__wrapper" },
              [
                _c("DeliverableListTags", {
                  attrs: {
                    deliverable: _vm.deliverableDetail,
                    namespace: _vm.namespace
                  },
                  on: { "tag-created": _vm.updateDeliverableTags }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.relatedTags.length
              ? _c(
                  "div",
                  { staticClass: "trending-tags" },
                  [
                    _c("label", [_vm._v("Trending tags:")]),
                    _vm._v(" "),
                    _vm._l(_vm.relatedTags, function(relatedTag, index) {
                      return _c(
                        "a",
                        {
                          key: "relate-tag" + index,
                          staticClass: "badge badge-success ml-2",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setTag(relatedTag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(relatedTag.name))]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "social_media_plan_details"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "questions"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "responses"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "notes_research"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableDetail.customFields, {
                      field_key: "location_text"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableDetail,
                              customField: field,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "priority"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                },
                                on: {
                                  "priority-updated":
                                    _vm.onDeliverablePriorityUpdated
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-right": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "start_date"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-left": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "end_date"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "start_datetime"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "end_datetime"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "publish_datetime"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableDetail.templateCustomFields,
                          { field_key: "marketing_officer" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "b-tabs",
                          {
                            staticClass: "field-tabs",
                            attrs: {
                              "content-class": "field-tab-content",
                              fill: ""
                            },
                            model: {
                              value: _vm.currentTab,
                              callback: function($$v) {
                                _vm.currentTab = $$v
                              },
                              expression: "currentTab"
                            }
                          },
                          [
                            _vm.hasContactFields()
                              ? _c(
                                  "b-tab",
                                  {
                                    staticClass: "field-tab-research field-box",
                                    attrs: { active: "", title: "Contact" }
                                  },
                                  [
                                    _c("DeliverableContact", {
                                      attrs: {
                                        deliverableDetail: _vm.deliverableDetail
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasChat()
                              ? _c(
                                  "b-tab",
                                  {
                                    staticClass: "field-tab-chat",
                                    attrs: {
                                      lazy: _vm.lazyLoadChat,
                                      title: "Chat"
                                    },
                                    on: { click: _vm.turnOffLazy }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "chat-wrapper" },
                                      [
                                        _c("Chat", {
                                          attrs: {
                                            primaryParticipantId:
                                              _vm.deliverableDetail.id,
                                            primaryParticipantTitle:
                                              _vm.deliverableDetail.title,
                                            primaryParticipantType:
                                              _vm.deliverableDetail
                                                .deliverable_template_id,
                                            chatNamespace: "deliverableChat",
                                            shouldRefreshMessages:
                                              _vm.currentTab == 1
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "website"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-right": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "interview_given"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-right": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "referred_to_external"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "french_request"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(_vm.deliverableDetail.customFields, {
                          field_key: "language"
                        }),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 field-box" }, [
                      _c("div", { staticClass: "field-box__header" }, [
                        _c(
                          "div",
                          { staticClass: "dropdown" },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass:
                                  "add-resource-button exclude-outside-click d-inline-block",
                                attrs: {
                                  title: "Add resource",
                                  "data-toggle": "dropdown",
                                  "aria-expanded": "false",
                                  "data-reference": "parent"
                                }
                              },
                              [_vm._v("Resources")]
                            ),
                            _vm._v(" "),
                            _c("plus-button", {
                              attrs: {
                                "data-toggle": "dropdown",
                                "aria-expanded": "false",
                                "data-reference": "parent"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu deliverable-resource-type-menu"
                              },
                              _vm._l(_vm.optionsForLinkType, function(type, i) {
                                return _c(
                                  "a",
                                  {
                                    key: i,
                                    staticClass: "dropdown-item",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addResourceMenuItemClick(
                                          type,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "link-type-icon",
                                      attrs: {
                                        src: require("@/csmworkflow/img/" +
                                          type.icon)
                                      }
                                    }),
                                    _vm._v(" " + _vm._s(type.name))
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-box__content" },
                        _vm._l(
                          _vm._.filter(_vm.deliverableDetail.customFields, {
                            field_key: "link_url"
                          }),
                          function(resource, index) {
                            return _c(
                              "div",
                              {
                                key: "link_url-" + index,
                                staticClass: "resource-box"
                              },
                              [
                                _c("div", { staticClass: "media" }, [
                                  _c("img", {
                                    staticClass: "link-type-icon",
                                    staticStyle: { "margin-right": "3px" },
                                    attrs: {
                                      src: require("@/csmworkflow/img/" +
                                        _vm.getLinkTypeObject(
                                          _vm.customChildFieldValue(
                                            "link_type",
                                            resource.id
                                          )
                                        ).icon),
                                      draggable: "false"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "media-body" },
                                    [
                                      _c("div", {
                                        staticClass: "resource-box__url"
                                      }),
                                      _vm._v(" "),
                                      resource.value
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: resource.value,
                                                target: "_blank",
                                                id: "resource-" + index
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.openCopyLinkModal(
                                                    resource.value,
                                                    $event,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.customChildFieldValue(
                                                    "link_label",
                                                    resource.id
                                                  ) || resource.value
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-tooltip",
                                        {
                                          attrs: {
                                            target: "resource-" + index,
                                            noninteractive: "",
                                            triggers: "manual"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-check",
                                            staticStyle: {
                                              color: "'var(--wf-primary)'"
                                            }
                                          }),
                                          _vm._v(" Link Copied!")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !resource.value
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.getResourceHref(
                                                  resource.value,
                                                  resource.id
                                                ),
                                                target: "_blank",
                                                id: "resource-" + index
                                              },
                                              on: {
                                                click: _vm.setCookieForDownload
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.customChildFieldValue(
                                                    "link_label",
                                                    resource.id
                                                  ) || resource.value
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !(
                                        !_vm.userAbilities.editMediaCall ||
                                        _vm.deliverableDetail.permissions
                                          .viewOnly
                                      )
                                        ? _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              staticClass: "edit-resource-btn",
                                              attrs: {
                                                title: "Edit resource",
                                                href: "#"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.editResource(
                                                    resource
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-edit"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.customChildFieldValue(
                                        "link_notes",
                                        resource.id
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "resource-box__notes"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.customChildFieldValue(
                                                    "link_notes",
                                                    resource.id
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          }
                        ),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "div",
              { staticClass: "add-task-button-mobile" },
              [
                !(
                  !_vm.userAbilities.editMediaCall ||
                  _vm.deliverableDetail.permissions.viewOnly
                )
                  ? _c(
                      "b-button",
                      {
                        staticClass: "add-task-btn",
                        attrs: { variant: "theme" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.createTask.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v("\n          Add Task\n          "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.addingTask,
                                expression: "addingTask"
                              }
                            ],
                            staticClass:
                              "ml-2 spinner-border spinner-border-sm text-primary",
                            attrs: { role: "status" }
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading...")
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("TaskFieldLabels", {
              ref: "TaskFieldLabelsRef",
              attrs: {
                fullDeliverables: _vm.deliverableDetail,
                deliverableId: _vm.deliverableDetail.deliverableId,
                deliverable: _vm.deliverableDetail,
                tasks: _vm.deliverableDetail.tasks,
                namespace: _vm.namespace
              }
            }),
            _vm._v(" "),
            _c("TaskFields", {
              attrs: {
                fullDeliverables: _vm.deliverableDetail,
                deliverableId: _vm.deliverableDetail.deliverableId,
                deliverable: _vm.deliverableDetail,
                tasks: _vm.deliverableDetail.tasks,
                namespace: _vm.namespace
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "responsive-edit-modal-controls",
          class: _vm.showModalOptions ? "open" : ""
        },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn modal-more-controls",
              attrs: { title: "More options" },
              on: {
                click: function($event) {
                  _vm.showModalOptions = !_vm.showModalOptions
                }
              }
            },
            [
              _c("i", {
                staticClass: "fas",
                class: !_vm.showModalOptions
                  ? "fa-arrow-left"
                  : "fa-arrow-right"
              })
            ]
          ),
          _vm._v(" "),
          _vm.userAbilities.deleteMediaCall &&
          !_vm.deliverableDetail.permissions.viewOnly
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn delete-deliverable-btn",
                  attrs: { title: _vm.getDeleteDeliverableTitle },
                  on: {
                    click: function($event) {
                      return _vm.removeDeliverable(
                        _vm.deliverableDetail.deliverableId
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-trash-alt" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("DuplicateMediaCallBtn", {
            attrs: {
              deliverableId: _vm.deliverableDetail.deliverableId,
              namespace: _vm.namespace,
              deliverableTemplateId:
                _vm.deliverableDetail.deliverable_template_id
            }
          }),
          _vm._v(" "),
          _c("FeedbackBtn"),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn close-deliverable-btn",
              attrs: { title: "Close" },
              on: { click: _vm.onCloseModal }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveDeliverable },
          model: {
            value: _vm.showRemoveDeliverable,
            callback: function($$v) {
              _vm.showRemoveDeliverable = $$v
            },
            expression: "showRemoveDeliverable"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this deliverable?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Contact Removal",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveContact },
          model: {
            value: _vm.showRemoveContact,
            callback: function($$v) {
              _vm.showRemoveContact = $$v
            },
            expression: "showRemoveContact"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to unassign this contact?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Contact Removal",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveSpokesperson },
          model: {
            value: _vm.showRemoveSpokesperson,
            callback: function($$v) {
              _vm.showRemoveSpokesperson = $$v
            },
            expression: "showRemoveSpokesperson"
          }
        },
        [
          _c("p", [
            _vm._v("Are you sure you want to unassign this spokesperson?")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Contact Removal",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.onConfirmRemoveWho },
          model: {
            value: _vm.showRemoveWho,
            callback: function($$v) {
              _vm.showRemoveWho = $$v
            },
            expression: "showRemoveWho"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to unassign this outlet?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "createLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              "resource-parent": "deliverable",
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "editLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "linkCopyLinkModal",
            title: "Copy Link",
            "ok-only": "",
            "ok-title": "Done"
          }
        },
        [
          _c("LinkCopyLinkModal", {
            attrs: { linkUrl: _vm.linkCopyModalValue, namespace: _vm.namespace }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }